import { useState } from "react";
import { useHistory } from "react-router";
import { useAppContext } from "../../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../../controller/article/ArticleController";
import MessageType from "../../../../../utils/MessageType";
import { handleErrorMessage, parseArticleForBackend } from "../../../../../utils/Utils";

interface OverviewServiceType {
  articleSave: any;
  submitDisabled: boolean;
  createOverallPdf: () => void;
  createOverall: boolean;
  checkbox: any;
  handleChange: any;
  confirmSubmission: boolean;
  confirmSubmissionAction: any;
}

export default function OverviewService({ article }: any): OverviewServiceType {
  const { axiosArticleUpdate, axiosGetArticleOverallPdf }: ArticleControllerType = ArticleController();
  const { showMessage, setBlockUI } = useAppContext();
  const [createOverall, setCreateOverall] = useState<boolean>(false);
  const [confirmSubmission, setConfirmSubmission] = useState<boolean>(false);
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);
  const [checkbox, setCheckbox] = useState({ one: false, two: article.languageService });

  const handleChange = (event: any) => {
    setCheckbox({ ...checkbox, [event.target.name]: event.target.checked });
  };

  const history = useHistory();

  const confirmSubmissionAction = () => {
    setConfirmSubmission(!confirmSubmission);
    setSubmitDisabled(false);
  };

  const articleSave = () => {
    setBlockUI(true);
    let newArticle = {
      isCompleted: true,
      ...parseArticleForBackend(article),
      languageService: checkbox.two,
      authorsIds: article.articleAuthors ? article.articleAuthors.map((a: any) => a.id) : undefined,
    };
    setSubmitDisabled(true);
    axiosArticleUpdate(newArticle)
      .then((response: any) => {
        setBlockUI(false);
        showMessage("Article is successfully submited.", MessageType.SUCCESS);
        history.push("/manuscript/view");
      })
      .catch((error: any) => {
        setBlockUI(false);
        setSubmitDisabled(false);
        handleErrorMessage(showMessage, error);
      });
  };

  const createOverallPdf = () => {
    setBlockUI(true);
    axiosGetArticleOverallPdf(article.id)
      .then((response: any) => {
        window.open(response.data, "_blank");
        setCreateOverall(true);
        setBlockUI(false);
      })
      .catch((error: any) => {
        setCreateOverall(false);
        setBlockUI(false);
        setSubmitDisabled(false);
        handleErrorMessage(showMessage, error);
      });
  };

  return {
    articleSave,
    submitDisabled,
    createOverallPdf,
    createOverall,
    checkbox,
    handleChange,
    confirmSubmission,
    confirmSubmissionAction,
  };
}

export type { OverviewServiceType };
